export default {
	title: 'favorites',
	components: [{ title: 'favorites', component: 'favorites_gen_1' }],
};
